import React from "react";
import { Globe, Users, Wrench, Rocket } from "lucide-react";

const OurMission = () => {
  const missions = [
    {
      icon: <Globe className="w-7 h-7 text-primary" />,
      text: (
        <>
          Rendre les compétences maker et STEAM <strong className="text-primary">accessibles à tous en Afrique</strong>.
        </>
      ),
    },
    {
      icon: <Users className="w-7 h-7 text-primary" />,
      text: (
        <>
          Relier les talents africains à des <strong className="text-primary">tuteurs et mentors modèles</strong> des meilleures universités et labs du monde (MIT, Stanford, Sorbonne, Maker’s Asylum…).
        </>
      ),
    },
    {
      icon: <Wrench className="w-7 h-7 text-primary" />,
      text: (
        <>
          Valoriser la <strong className="text-primary">création par la pratique</strong>, où chaque module est un projet concret.
        </>
      ),
    },
    {
      icon: <Rocket className="w-7 h-7 text-primary" />,
      text: (
        <>
          Former une génération d’<strong className="text-primary">innovateurs, créateurs et entrepreneurs</strong> capables de résoudre les défis locaux et globaux.
        </>
      ),
    },
  ];

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        {/* Titre */}
        <h2 className="text-title font-bold text-dark-1 text-center mb-12">
          Notre Mission
        </h2>

        {/* Liste des missions */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {missions.map((mission, index) => (
            <div
              key={index}
              className="flex items-start space-x-4 bg-gray-50 rounded-2xl shadow-sm p-6 hover:shadow-md transition"
            >
              <div className="flex-shrink-0">{mission.icon}</div>
              <p className="text-gray-700 leading-relaxed">{mission.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurMission;
